import React from "react";
import {
  Button,
  Box,
  Image,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from "@chakra-ui/react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Documents.css";

function DocumentsDetailView() {
  const navigate = useNavigate();
  const location = useLocation();
  const document = location.state?.document;

  if (!document) return <div>No document data available</div>;

  return (
    <div className="overflow-y-scroll" style={{ height: "92vh", padding: "1rem" }}>
      <Tabs variant="enclosed" size="md">
        <TabList>
          <Tab>Overview</Tab>
        </TabList>

        <TabPanels>
          <TabPanel>
            <Button
              className="create-button py-1"
              mb={4}
              onClick={() => navigate(-1)}
              style={{ marginBottom: "1rem" }}
            >
              Back
            </Button>

            {/* Document Basic Information */}
            {/* <div className="card card-detail mb-4">
              <div className="card-header">
                <h4>Document Basic Information</h4>
              </div>
              <div className="card-body">
                <table className="table">
                  <tbody>
                    <tr>
                      <th>Title</th>
                      <td>{document.title || "N/A"}</td>
                    </tr>
                    <tr>
                      <th>Created Date</th>
                      <td>{document.createdDate || "N/A"}</td>
                    </tr>
                    <tr>
                      <th>Aadhaar Card</th>
                      <td>{document.aadhaarCard || "N/A"}</td>
                    </tr>
                    <tr>
                      <th>Photo</th>
                      <td>{document.photo || "N/A"}</td>
                    </tr>
                    <tr>
                      <th>Registry/House Tax/Full Payment Agreement</th>
                      <td>{document.registry || "N/A"}</td>
                    </tr>
                    <tr>
                      <th>Electricity Bill</th>
                      <td>{document.electricityBill || "N/A"}</td>
                    </tr>
                    <tr>
                      <th>Cancel Cheque/Bank Passbook</th>
                      <td>{document.cancelCheque || "N/A"}</td>
                    </tr>
                    <tr>
                      <th>Mobile No.</th>
                      <td>{document.mobileNo || "N/A"}</td>
                    </tr>
                    <tr>
                      <th>Email ID</th>
                      <td>{document.emailId || "N/A"}</td>
                    </tr>
                    {document.items && document.items.length > 0 && (
                      <tr>
                        <th>Document Required for Kyc</th>
                        <td>
                          <ul className="list-group">
                            {document.items.map((doc, index) => (
                              <li key={index} className="list-group-item">
                                {doc.document}
                              </li>
                            ))}
                          </ul>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div> */}

            {/* Additional Document Items Table */}
            <div className="mb-4">
              <div className="card-body">
                <h6 className="card-title">Document Items</h6>
                {(document.items && document.items.length > 0) || true ? (
                  <table
                    className="table-class"
                    style={{ marginBottom: "50px", width: "100%" }}
                  >
                    <thead>
                      <tr>
                        <th>Document</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(document.items && document.items.length > 0
                        ? document.items
                        : [
                            { document: "Aadhaar Card" },
                            { document: "Photo" },
                            { document: "Registry/House Tax/Full Payment Agreement" },
                            { document: "Electricity Bill" },
                            { document: "Cancel Cheque/Bank Passbook" },
                            { document: "Mobile No." },
                            { document: "Email ID" },
                          ]
                      ).map((item, index) => (
                        <tr key={index}>
                          <td className="border" style={{ minWidth: "200px" }}>
                            {item.document || "N/A"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div>No document items available</div>
                )}
              </div>
            </div>

            {/* Guidelines Card */}
            <div className="card card-detail mb-4">
              <div className="card-header">
                <h4>Guidelines</h4>
              </div>
              <div
                className="card-body border p-2 rounded DocumentsDetail"
                dangerouslySetInnerHTML={{ __html: document.guidelines || "" }}
              />
            </div>

            {/* Note Card */}
            <div className="card card-detail mb-4">
              <div className="card-header">
                <h4>Note</h4>
              </div>
              <div
                className="card-body border p-2 rounded DocumentsDetail"
                dangerouslySetInnerHTML={{ __html: document.note || "" }}
              />
            </div>

            {/* Contact Details Card */}
            <div className="card card-detail mb-4">
              <div className="card-header">
                <h4>Contact Details for Respective Department</h4>
              </div>
              <div
                className="card-body border p-2 rounded DocumentsDetail"
                dangerouslySetInnerHTML={{ __html: document.contactDetails || "" }}
              />
            </div>

            {/* Bank Detail Card */}
            <div className="card card-detail mb-4">
              <div className="card-header">
                <h4>Online Payment Details</h4>
              </div>
              <div className="card-body border rounded-md p-1 shadow-md mt-2">
                <table className="table table-bordered text-center align-middle">
                  <thead className="table-light">
                    <tr>
                      <th>Bank Details</th>
                      <th>G Pay No.</th>
                      <th>UPI ID</th>
                      <th>Scanner</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <div className="fw-bold">Bank Account Name :</div>
                        <div className="fw-bold">Bank Name :</div>
                        <div className="fw-bold">Acc No. :</div>
                        <div className="fw-bold">IFSC Code :</div>
                      </td>
                      <td>{document.gPayNo || "N/A"}</td>
                      <td>{document.upiId || "N/A"}</td>
                      <td style={{ width: "180px" }}>
                        {document.qrImage ? (
                          <Image
                            src={document.qrImage}
                            alt="Uploaded QR"
                            border="1px solid #ccc"
                            borderRadius="6"
                            p="1"
                            boxSize="150px"
                            objectFit="cover"
                            margin="auto"
                          />
                        ) : (
                          <div
                            style={{
                              width: "150px",
                              height: "150px",
                              border: "1px dashed gray",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              margin: "auto",
                              borderRadius: "6px",
                              color: "#777",
                            }}
                          >
                            QR Image Here
                          </div>
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </div>
  );
}

export default DocumentsDetailView;
